import "../../../../../shared/client/jst.js";

AddressAvailability.Status.Views.Badge = class Badge extends Backbone.View {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
    this.badgePayload = this.badgePayload.bind(this);
    this.setUpRenderInterval = this.setUpRenderInterval.bind(this);
    this.hasValidDates = this.hasValidDates.bind(this);
    this.isClosingSoon = this.isClosingSoon.bind(this);
    this.isOpen = this.isOpen.bind(this);
    this.isClosed = this.isClosed.bind(this);
    this.isTwentyFourSeven = this.isTwentyFourSeven.bind(this);
    this.closingSoonStartTime = this.closingSoonStartTime.bind(this);
    this.t = this.t.bind(this);
    this.getClosesInText = this.getClosesInText.bind(this);
    this.getNextClosesText = this.getNextClosesText.bind(this);
    this.getNextOpenText = this.getNextOpenText.bind(this);
    this.getFormatedTime = this.getFormatedTime.bind(this);
    this.timeFormat = this.timeFormat.bind(this);
    this.closesInMinutes = this.closesInMinutes.bind(this);
    this.parsedClosingTime = this.parsedClosingTime.bind(this);
    this.parsedOpeningTime = this.parsedOpeningTime.bind(this);
    this.closingTime = this.closingTime.bind(this);
    this.openingTime = this.openingTime.bind(this);
  }

  initialize(options = {}) {
    this.options = options;
    this.listenTo(this.model, "change:staleAt", this.setUpRenderInterval);
    return this.listenTo(this.model, "change:staleAt", this.render);
  }

  // RENDERING

  render() {
    if (this.hasValidDates()) {
      this.$el.html(window.Sparkle.Client.jstTemplate(this.template)(this.badgePayload()));
    }
    return this;
  }

  // `status` keys the CSS modifier classes; `statusLabel` is the visitor-facing
  // (localized) text.
  badgePayload() {
    if (this.isClosingSoon()) {
      return { status: "closing", statusLabel: this.t("status_closing"), statusText: this.getClosesInText() };
    } else if (this.isOpen()) {
      return { status: "open", statusLabel: this.t("status_open"), statusText: this.getNextClosesText() };
    } else {
      return { status: "closed", statusLabel: this.t("status_closed"), statusText: this.getNextOpenText() };
    }
  }

  // FETCH HELPERS

  setUpRenderInterval() {
    clearInterval(this.renderIntervalId);
    clearInterval(this.renderAlignmentTimeoutId);

    const renderIntervalStart = moment().startOf("m").add(1, "m"); // set it up to be the start of the next minute so that it updates on the minute

    return (this.renderAlignmentTimeoutId = setTimeout(
      () => {
        this.render(); // render now
        return (this.renderIntervalId = setInterval(this.render, 60000));
      }, // Render every minute from now
      renderIntervalStart.diff(moment()),
    ));
  }

  // HELPERS
  hasValidDates() {
    if (this.isTwentyFourSeven()) {
      return true;
    }
    if (this.parsedOpeningTime().toString().includes("Invalid")) {
      return false;
    }
    if (this.parsedClosingTime().toString().includes("Invalid")) {
      return false;
    }
    return true;
  }

  isClosingSoon() {
    if (this.isTwentyFourSeven()) {
      return false;
    }

    return (
      moment().isBetween(this.closingSoonStartTime(), this.parsedClosingTime()) ||
      moment().isSame(this.parsedClosingTime())
    );
  }

  isOpen() {
    return this.model.get("open");
  }

  isClosed() {
    return !this.model.get("open");
  }

  isTwentyFourSeven() {
    return !this.model.get("nextClosedAt");
  }

  closingSoonStartTime() {
    return this.parsedClosingTime().subtract(1, "hour");
  }

  t(key) {
    return AddressAvailability.Status.t(key);
  }

  getClosesInText() {
    return this.t("closes_in")
      .replace("%{minutes}", `${this.closesInMinutes()}`)
      .replace("%{next_open}", this.getNextOpenText());
  }

  getNextClosesText() {
    if (this.isTwentyFourSeven()) {
      return this.t("twenty_four_seven");
    }

    const formatedTime = this.getFormatedTime(this.parsedClosingTime());
    return this.t("closes_at").replace("%{time}", formatedTime);
  }

  getNextOpenText() {
    const time = this.parsedOpeningTime();
    if (!time.isValid()) {
      return this.t("currently_closed");
    }
    const formatedTime = this.getFormatedTime(time);
    return this.t("opens_at").replace("%{time}", formatedTime);
  }

  getFormatedTime(time) {
    const parsedTime = moment.parseZone(time);
    const format = this.timeFormat(parsedTime);

    const formats = {
      sameDay: format,
      nextDay: format,
      nextWeek: `ddd ${format}`,
    };

    return parsedTime.calendar(null, formats);
  }

  timeFormat(time) {
    let format;
    if (time.minutes() === 0) {
      return (format = "h A");
    } else {
      return (format = "h:mm A");
    }
  }

  closesInMinutes() {
    return this.parsedClosingTime().diff(moment().startOf("minute"), "minutes");
  }

  parsedClosingTime() {
    return moment.parseZone(this.closingTime());
  }

  parsedOpeningTime() {
    return moment.parseZone(this.openingTime());
  }

  closingTime() {
    return this.model.get("nextClosedAt");
  }

  openingTime() {
    return this.model.get("nextOpenAt");
  }
};
AddressAvailability.Status.Views.Badge.prototype.tagName = "section";
AddressAvailability.Status.Views.Badge.prototype.className = "address-availability address-availability--badge";
AddressAvailability.Status.Views.Badge.prototype.template =
  "application/components/address_availability/status/templates/badge";
